function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from 'react';
var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M8.4,10.281v2.465a.7.7,0,0,0,.7.7H13.3a.7.7,0,0,0,.7-.7V6.558a1.12,1.12,0,0,0-.328-.792L7.791.886a1.118,1.118,0,0,0-1.582,0L.328,5.766A1.12,1.12,0,0,0,0,6.558v6.188a.7.7,0,0,0,.7.7H4.9a.7.7,0,0,0,.7-.7V10.281A1.4,1.4,0,0,1,7,8.881H7A1.4,1.4,0,0,1,8.4,10.281Z"
});
var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    viewBox: "0 0 14 14"
  }, props), _ref);
};
export default __webpack_public_path__ + "static/media/home.825d06dd.svg";
export { SvgComponent as ReactComponent };